import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, Instructions } from '@coursera/components';

import styles from './plugin-container-quiz.module.scss';

const cx = classnames.bind(styles);

export const PluginContainerQuiz = ({
  children,
  isComplete,
  next,
  nextLabel,
  twoTone,
  ...rest
}) => {
  return (
    <div className={cx({ container: true, 'two-tone': twoTone })}>
      <div className={styles.instructions}>
        <Instructions {...rest} />
      </div>

      <div className={styles.content}>{children}</div>

      <Button.Container fixed hidden={!isComplete}>
        <Button onClick={next}>{nextLabel}</Button>
      </Button.Container>
    </div>
  );
};

PluginContainerQuiz.propTypes = {
  children: PropTypes.node,
  isComplete: PropTypes.bool,
  next: PropTypes.func,
  nextLabel: PropTypes.string,
  twoTone: PropTypes.bool,
};

PluginContainerQuiz.defaultProps = {
  nextLabel: 'Continue',
};
